import { createRouter, createWebHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import { getToken } from '../utils/auth';
import Login from '@/views/Login.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      component: Login,
      name: 'Login',
      meta: { requiresAuth: false }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('@/views/ForgotPassword.vue')
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: () => import('@/views/ResetPassword.vue')
    },

    {
      path: '/',
      component: AppLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () => import('@/views/Dashboard.vue')
        },
        {
          path: '/product-category',
          name: 'ProductCategory',
          component: () => import('@/views/ProductCategory.vue')
        },
        {
          path: '/product',
          name: 'Product',
          component: () => import('@/views/Product.vue')
        },
        {
          path: '/product-items',
          name: 'ProductItems',
          component: () => import('@/views/ProductItems.vue')
        },
        {
          path: '/discount-product-items',
          name: 'DiscountProductList',
          component: () => import('@/views/DiscountProductItemsList.vue')
        },
        {
          path: '/countries',
          name: 'Countries',
          component: () => import('@/views/Country.vue')
        },
        {
          path: '/cities',
          name: 'Cities',
          component: () => import('@/views/City.vue')
        },
        {
          path: '/wages',
          name: 'Wages',
          component: () => import('@/views/Wage.vue')
        },
        {
          path: '/colors',
          name: 'Colors',
          component: () => import('@/views/Color.vue')
        },
        {
          path: '/product-usage',
          name: 'ProductUsage',
          component: () => import('@/views/ProductUsage.vue')
        },
        {
          path: '/product-type',
          name: 'ProductType',
          component: () => import('@/views/ProductType.vue')
        },
        {
          path: '/karat',
          name: 'Karat',
          component: () => import('@/views/Karat.vue')
        },
        {
          path: '/returning-items',
          name: 'ReturningItems',
          component: () => import('@/views/ReturningItems.vue')
        },
        {
          path: '/equipment',
          name: 'Equipment',
          component: () => import('@/views/Equipment.vue')
        },
        {
          path: '/notification',
          name: 'Notification',
          component: () => import('@/views/Notification.vue')
        },
        {
          path: '/off-days',
          name: 'OffDays',
          component: () => import('@/views/OffDay.vue')
        },
        {
          path: '/brands',
          name: 'Brands',
          component: () => import('@/views/Brand.vue')
        },
        {
          path: '/special-orders',
          name: 'SpecialOrder',
          component: () => import('@/views/SpecialOrder.vue')
        },
        {
          path: '/orders',
          name: 'Orders',
          component: () => import('@/views/Order.vue')
        },
        {
          path: '/orders/:id',
          name: 'OrderDetail',
          component: () => import('@/views/OrderDetail.vue')
        },
        {
          path: '/mehr-bon-setting',
          name: 'MehrBonSetting',
          component: () => import('@/views/MehrBonSetting.vue')
        },
        {
          path: '/article-category',
          name: 'ArticleCategory',
          component: () => import('@/views/ArticleCategory.vue')
        },
        {
          path: '/article-category',
          name: 'PageCategory',
          component: () => import('@/views/ArticleCategory.vue')
        },
        {
          path: '/article-category',
          name: 'NewsCategory',
          component: () => import('@/views/ArticleCategory.vue')
        },
        {
          path: '/article',
          name: 'Article',
          component: () => import('@/views/Article.vue')
        },
        {
          path: '/article',
          name: 'NewsArticle',
          component: () => import('@/views/Article.vue')
        },
        {
          path: '/article',
          name: 'PageArticle',
          component: () => import('@/views/Article.vue')
        },
        {
          path: '/slider',
          name: 'Slider',
          component: () => import('@/views/Slider.vue')
        },
        {
          path: '/report',
          name: 'Report',
          component: () => import('@/views/Report.vue')
        },
        {
          path: '/price-history',
          name: 'PriceHistory',
          component: () => import('@/views/PriceUpdateHistory.vue')
        },
        {
          path: '/banner',
          name: 'Banner',
          component: () => import('@/views/Banner.vue')
        },
        {
          path: '/payment-methods',
          name: 'PaymentMethods',
          component: () => import('@/views/PaymentMethod.vue')
        },
        {
          path: '/gift-cards',
          name: 'GiftCards',
          component: () => import('@/views/GiftCard.vue')
        },
        {
          path: '/shipment',
          name: 'Shipment',
          component: () => import('@/views/Shipment.vue')
        },
        {
          path: '/payment-methods',
          name: 'PaymentMethod',
          component: () => import('@/views/PaymentMethod.vue')
        },
        {
          path: '/warranty',
          name: 'Warranty',
          component: () => import('@/views/Warranty.vue')
        },
        {
          path: '/ticket-department',
          name: 'TicketDepartment',
          component: () => import('@/views/TicketDepartment.vue')
        },
        {
          path: '/ticket',
          name: 'Ticket',
          component: () => import('@/views/Ticket.vue')
        },
        {
          path: '/ticket-detail/:id',
          name: 'TicketDetail',
          component: () => import('@/views/TicketDetail.vue')
        },
        {
          path: '/invoices',
          name: 'Invoices',
          component: () => import('@/views/Invoices.vue')
        },
        {
          path: '/invoices/:id',
          name: 'ShowInvoice',
          component: () => import('@/views/ShowInvoice.vue')
        },
        {
          path: '/customers',
          name: 'CustomersList',
          component: () => import('@/views/CustomerList.vue')
        },
        {
          path: '/admins',
          name: 'AdminsList',
          component: () => import('@/views/Admins.vue')
        },
        {
          path: '/roles',
          name: 'RolesList',
          component: () => import('@/views/Role.vue')
        },
        {
          path: '/settings',
          name: 'AppSettings',
          component: () => import('@/views/AppSettingsPage.vue')
        },
        {
          path: '/comments',
          name: 'Comments',
          component: () => import('@/views/Comments.vue')
        },
        {
          path: '/contacts',
          name: 'Contacts',
          component: () => import('@/views/Contacts.vue')
        },
        {
          path: '/discounts',
          name: 'Discounts',
          component: () => import('@/views/Discount.vue')
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!token) {
      router.push('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
